/**
 * Раздача веса блюда по его составу.
 *
 * Требование жёсткое: сумма частей обязана сойтись с целым ровно. Веса
 * ингредиентов сохраняются как доли — weight_g / вес блюда × 100, — и если
 * сумма разошлась на грамм, доли дают не 100, а при следующем открытии блюда
 * из них собирается состав не того веса. Округли мы каждую часть сама по себе,
 * состав на 250 г давал бы 249,3.
 *
 * Поэтому раздаём по наибольшему остатку: каждому целую часть, а единицы
 * сетки, оставшиеся от округления вниз, — тем, у кого дробный хвост длиннее.
 * Сетка та же, что у показа веса: до десятых ниже 10 г, до целого выше.
 */

// Округление веса: до десятых ниже 10 г, до целого выше
export function roundWeight(w) {
  return w < 10 ? Math.round(w * 10) / 10 : Math.round(w)
}

/**
 * @param {number[]} base   веса, задающие пропорции (в любом масштабе)
 * @param {number}   target сколько между ними разделить, граммы
 * @returns {number[]} веса, сумма которых равна target на сетке округления
 */
export function distributeWeights(base, target) {
  const total = Number(target) || 0
  const baseSum = base.reduce((s, w) => s + (Number(w) || 0), 0)
  if (!(baseSum > 0) || !(total > 0)) return base.map(w => Number(w) || 0)

  const step = total >= 10 ? 1 : 0.1
  const k = total / baseSum
  const exact = base.map(w => (Number(w) || 0) * k / step)
  const units = exact.map(v => Math.floor(v))
  let rest = Math.round(total / step) - units.reduce((s, v) => s + v, 0)
  const byRemainder = exact
    .map((v, i) => i)
    .sort((a, b) => (exact[b] - units[b]) - (exact[a] - units[a]))
  for (let n = 0; rest > 0 && n < byRemainder.length; n++, rest--) units[byRemainder[n]] += 1
  return units.map(u => Math.round(u * step * 10) / 10)
}
